export const interpolateColor = ({ orderOfImportance, maxOrderOfImportance, colorStops }) => {
	const fraction = (orderOfImportance - 1) / (maxOrderOfImportance - 1)
	let startStop
	let endStop
	for (let i = 0; i < colorStops.length - 1; i++) {
		if (fraction >= colorStops[i].t && fraction <= colorStops[i + 1].t) {
			startStop = colorStops[i]
			endStop = colorStops[i + 1]
			break
		}
	}
	// Fallback if no segment is found (shouldn't happen)
	if (!startStop || !endStop) {
		startStop = colorStops[0]
		endStop = colorStops[colorStops.length - 1]
	}
	// Calculate the local fraction between the two stops.
	const localFraction = (fraction - startStop.t) / (endStop.t - startStop.t)
	const r = Math.round(startStop.rgba[0] + localFraction * (endStop.rgba[0] - startStop.rgba[0]))
	const g = Math.round(startStop.rgba[1] + localFraction * (endStop.rgba[1] - startStop.rgba[1]))
	const b = Math.round(startStop.rgba[2] + localFraction * (endStop.rgba[2] - startStop.rgba[2]))
	const a = startStop.rgba[3] + localFraction * (endStop.rgba[3] - startStop.rgba[3])
	return `rgba(${r}, ${g}, ${b}, ${a})`
}
